var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKpiTotalStrikersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 5.83333C13.3332 7.67305 11.8396 9.16667 9.99984 9.16667C8.16012 9.16667 6.6665 7.67305 6.6665 5.83333C6.6665 3.99362 8.16012 2.5 9.99984 2.5C11.8396 2.5 13.3332 3.99362 13.3332 5.83333V5.83333M9.99984 11.6667C6.78033 11.6667 4.1665 14.2805 4.1665 17.5H15.8332C15.8332 14.2805 13.2193 11.6667 9.99984 11.6667V11.6667",
    stroke: "#047857",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiTotalStrikersIcon);
export default __webpack_public_path__ + "static/media/kpi_total_strikers_icon.9c93f3ce3c1d3b597365a48d9d202269.svg";
export { ForwardRef as ReactComponent };